import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useHistory } from 'react-router';
import { pdfjs } from "react-pdf";
import lodash from 'lodash';

import backArrow from '../../../images/back-arrow-white.svg';
import ThankYouImage from '../../../images/ThankYouImage.svg';

import useTranslation from '../../../hooks/use-translation';
import useLoader from '../../../hooks/use-loader';
import { parseQueryString } from '../../../utils/utils';
import config from '../../../config.json';
import { isJhhIdVerified } from '../Utils/isJhhIdVerified';
import UploadVaccineComponent from "../UploadVaccineComponent/index";
import GetLastVaccinationDetails from '../GetLastVaccinationDetails';

import './cowin.css'
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const MAXSIZE = 10485760;
const acceptedImgFileType = ["image/jpeg", "image/png", "image/jpg"]
const vaccinationCertiUploadUrl = config.covid_vacc_base_url + 'v1/upload-reports/'

let auth_token;
let source_id;
let source_user_id;
let source_relation;
let source_user_relation_id;
let user_name;

const VaccinationCertiCowin = () => {
  const { t } = useTranslation();
  const [certiCount, setCertiCount] = useState(0);
  const [sessionError, setSessionError] = useState();
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const { showLoading, hideLoading, loadingCount } = useLoader();
  const history = useHistory();
  const params = parseQueryString();
  const user_details = useRef()
  const urlParams = new URLSearchParams(window.location.search);


  useEffect(() => {
    auth_token = lodash.get(params, "auth_token");
    source_id = lodash.get(params, "source_id").toLowerCase();
    source_user_id = lodash.get(params, "source_user_id");
    source_relation = lodash.get(params, "source_relation");
    source_user_relation_id = lodash.get(params, "source_user_relation_id");
    user_name = lodash.get(params, "t");
    if (!auth_token || !source_id || !source_user_id || !source_relation || (source_user_relation_id == undefined) || !user_name) {
      setSessionError("Session expired, please login again");
    }
    else {
      user_name = atob(user_name);
      user_details.current = {
        auth_token,
        source_id,
        source_user_id,
        source_relation,
        source_user_relation_id
      };
      showLoading()
      isJhhIdVerified(user_details.current)
        .then(response => {
          if ((String(lodash.get(response, "validated")).toLowerCase() == "no") || !(lodash.get(response, "jhh_id"))) {
            hideLoading()
            history.replace(`/vaccination-certificate/verifyjhhid?${urlParams.toString()}`)
          }
          else {
            user_details.current = {
              ...user_details.current, jhh_id: lodash.get(response, "jhh_id")
            }
            hideLoading();
          }
        })
        .catch(error => {
          hideLoading()
          setSessionError(error.message || "Session expired, please login again")
        })
    }
  }, [])

  if (sessionError) {
    return (
      <div className="paddingLarge vaccine-certi-handler">
        <p className="font-color-red">{sessionError}</p>
      </div>
    )
  }

  if (loadingCount) {
    return (
      <div></div>
    )
  }

  return (
    <div className="paddingLarge vaccine-certi-handler">
      { showSuccessScreen ?
        <>
          <div className="no-certi-img-caption-container">
            <div className="person-name">
              <img className="back-arrow express-interest-back-arrow" onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} src={backArrow} alt="arrow back"></img>
              <div className="express-interest-header-text">{t('COWIN_CERT_UPLOAD_HEADER')}</div>
            </div>
            <br />
            <br />
            <img src={ThankYouImage} alt="Thank You Image" />
            <h3>{t('EOI_THANK_YOU')}</h3>
            <div className="certificate-upload-success">{t('CERTIFICATE_UPLOAD_SUCCESS')}</div>
            <br />
            <br />
            <button className="go-to-dashboard-button" onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)}>{t('GO_TO_DASHBOARD')}</button>
          </div>
        </>
        :
        <>
          <div>
            <div className="person-name">
              <img className="back-arrow express-interest-back-arrow" onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} src={backArrow} alt="arrow back"></img>
              <div className="express-interest-header-text">{t('COWIN_CERT_UPLOAD_HEADER')}</div>
            </div>
            {certiCount === 0 ?
              <div className="no-certi-container">
                <div className="no-certi-img-caption-container">
                  <br />
                  <p className="upload-certi-text">{`${t('UPLOADED_CERTI_TEXT')}`}<span className="font-color-blue">{user_name ? user_name : ""}</span> {`${t('AND_JHH_ID')}`} <span className="font-color-blue">{lodash.get(user_details, "current.jhh_id") ? user_details.current.jhh_id : ""}</span></p>
                  <GetLastVaccinationDetails />
                  <UploadVaccineComponent _onSubmitFinish={()=>{setShowSuccessScreen(true)}} />
                </div>
              </div>
              :
              <div>
              </div>
            }
          </div>

        </>
      }
    </div>
  )
}

export default VaccinationCertiCowin;